export const BASE_CLASS = 'mt-ListFeatures'
export const ARIA_PRESENTATION_ROLE = 'presentation'
export const LAYOUTS = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal'
}
